var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',[_c('a',{attrs:{"href":'/en/message-search/?filters=&posted_date=desc&query=' + _vm.result[1] + '&limit=25&start=0'}},[_vm._v("Search "+_vm._s(_vm.result[0])+" with "+_vm._s(_vm.result[1]))])]),_vm._v(" "),_c('hr')])
}
var staticRenderFns = []

export { render, staticRenderFns }